import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  Link,
  Icon,
  PopoverContentProps,
  Portal,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  text?: string;
  withIcon?: boolean;
}

const InfoPopover: React.FC<
  React.PropsWithChildren<Props & PopoverContentProps>
> = ({ text, withIcon, children, ...props }) => {
  const { t } = useTranslation();

  return (
    <Popover>
      <PopoverTrigger>
        <Link variant="gray">
          {text ? text : t('READ')}
          {withIcon && <Icon name="GeneralActionsChevronDown" boxSize={4} />}
        </Link>
      </PopoverTrigger>
      <Portal>
        <PopoverContent {...props}>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverBody maxW="90%">{children}</PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default InfoPopover;
